import CompaniesSelect from "@components/common/CompaniesSelect"
import { SelectInput } from "@components/common/SelectInput"
import CreatedbySelect from "@components/Ticket/CreatedByFilter"
import { Col, Row } from "antd"

const OrderFilters = () => {
  return (
    <Row gutter={[6, 6]}>
      <CompaniesSelect span={4} />
      <Col xs={{ span: 24 }} xl={{ span: 4 }}>
        <CreatedbySelect />
      </Col>
      <SelectInput constant="ORDER_STATUSES" span={4} inputName="filterByStatus" search filter='status' placeholder="FILTERBYSTATUS" />
      <SelectInput constant="ORDER_TYPES" span={4} inputName="filterByType" search filter='type' placeholder="FILTERBYTYPE" />
    </Row>
  )
}

export default OrderFilters
